import React, { useRef, useState } from "react";
import useForm from "../../customHooks/useForm";
import InputField from "../CredentialsInput/InputField";
import SubmitButton from "../SubmitButton/SubmitButton";
import { useCustomer } from "../../customHooks/useCustomer";
import * as translator from "../../utils/translator";
import * as http from "../../utils/http";
import { clientConfig } from "../../config";
import ReCAPTCHA from "react-google-recaptcha";

// TODO: USE THIS COMPONENT IN QUESTIONNAIRE LOGINQUESTION TOO

interface LoginFormProps {
  language: string;
  className?: string; //"questionnaire-loginquestion-inputs-container" 
  submitButtonPlaceholder: string
  setStickyNotificationDetails: any
  country: string
  onLoginSuccess?: () => void
}

const LoginForm: React.FC<LoginFormProps> = ({
  language,
  className,
  submitButtonPlaceholder,
  setStickyNotificationDetails,
  country,
  onLoginSuccess,
}) => {


  const [submitButtonLoading, setSubmitButtonLoading] = useState(false);
  const { saveCustomer } = useCustomer();
  const reRef = useRef<ReCAPTCHA>(null);
  const loginFormAttributes = useForm(
    { email: "", loginPassword: "", country },
    language,
    undefined,
    { looseEmail: true }
  );

  const onSubmit = async (e: any) => {
    e.preventDefault();
    setSubmitButtonLoading(true);

    if (loginFormAttributes.validateForm()) {

      let captchaToken

      if (clientConfig.IS_RECAPTCHA_ENABLED) {
        captchaToken = await reRef.current?.executeAsync();
        reRef.current?.reset();
      }


      const requestBody = {...loginFormAttributes.form, captchaToken };

      http
        .postToServer(`auth/local/login`, requestBody, [http.MIDDLEWARES.CART_ORDER, http.MIDDLEWARES.ENCRYPTED_BODY])
        .then((response) => {

          //in here add usename to the request
          if (response.data.status === "ok") {

            // fire logged in event 

            saveCustomer({
              customerID: response.data.customerID,
              uuid: response.data.uuid,
              token: response.data.token,
              email: loginFormAttributes.form.email,
              optForSendables: response.data.optForSendables,
              fullName: response.data.customerFullName,
              loginSource: "loginForm",
              provider: response.data.provider || 'local',
              gender: response.data?.gender,
              lastPaidCategoryMention: response.data?.lastPaidCategoryMention,
            });
            onLoginSuccess?.();
          } else {
            setStickyNotificationDetails((currentDetails: any) => ({
              show: true,
              title: "Oops",//TODO:Translations
              content: translator.translate(language, "default", "StickyNotification/login_failed"),
              level: "error",
              showInfoIcon: true,
              refresh: !currentDetails.refresh
            }))
          }

        })
        .catch((error) => {

          let stickyContent = translator.translate(language, "my_account", `stickyNotifications/error/error`)

          if (error?.response?.data?.status === 'user_blocked') {
            stickyContent = translator.translate(language,"default",`StickyNotification/user_blocked`)
          }

          setStickyNotificationDetails((currentDetails: any) => ({
            show: true,
            title: "Oops",//TODO:Translations
            content: stickyContent,
            level: "error",
            showInfoIcon: false,
            refresh: !currentDetails.refresh
          }))
        })
        .finally(() => {
          setSubmitButtonLoading(false);
        })
    } else {
      setSubmitButtonLoading(false)
    }

  };
  
  return (
    <>
      <form onSubmit={onSubmit} className={className}>
        <InputField
          value={loginFormAttributes.form.email}
          errorMsg={loginFormAttributes.errorMessagePerField.email}
          onChange={(value: string) => {
            loginFormAttributes.updateForm("email", value);
          }}
          type="email"
          placeholder={"E-Mail"}
          language={language}
          mandatory
          onBlur={() => loginFormAttributes.onFieldBlur("email")}
          touched={loginFormAttributes.touched.email}
        />

        <InputField
          value={loginFormAttributes.form.loginPassword}
          errorMsg={loginFormAttributes.errorMessagePerField.loginPassword}
          onChange={(value: string) => {
            loginFormAttributes.updateForm("loginPassword", value);
          }}
          type="password"
          placeholder={translator.translate(
            language,
            "default",
            "LoginQuestion/password"
          )}
          language={language}
          mandatory
          onBlur={() => loginFormAttributes.onFieldBlur("loginPassword")}
          touched={loginFormAttributes.touched.loginPassword}
        />
        <input type="submit" hidden />

        {clientConfig.IS_RECAPTCHA_ENABLED &&
          <ReCAPTCHA
            sitekey={clientConfig.RECAPTCHA_SITE_KEY}
            size="invisible"
            ref={reRef}
          />
          }

      </form>

      <SubmitButton
        id={"login-form-submit"}
        language={language}
        loading={submitButtonLoading}
        onSubmit={onSubmit}
        width={"100%"}
        placeholder={submitButtonPlaceholder}
        fontsize={"20px"}
        className="linear-background-color-primary rounded-[12px]"
      />
    </>
  );
};

export default LoginForm;